module.exports = __webpack_public_path__ + "static/media/recompenseDash.13e3ae91.svg";